var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table',{attrs:{"data":_vm.mapedData,"stripe":"","max-height":"250","size":"mini","show-header":false}},[_c('el-table-column',{attrs:{"prop":"d"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }